import Effect from "@/roc/effects/Effect";
import EffectMechanic from "@/roc/effects/EffectMechanic";
class Happiness extends Effect {
    __amount;
    constructor(amount) {
        super(EffectMechanic.HAPPINESS);
        this.__amount = amount;
    }
    formatDescription() {
        return null;
    }
    clone() {
        return new Happiness(this.__amount);
    }
    hasAmountForEra(era) {
        return this.__amount[era] && this.__amount[era].length === 3 && this.__amount[era][0] > 0;
    }
    getRequired(era, level) {
        return this.__amount[era] ? this.__amount[era][level] : 0;
    }
}
export default Happiness;
